import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "ut-pdp"
};
const _hoisted_2 = {
  class: "pdp"
};
const _hoisted_3 = {
  class: "pdp-form"
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = {
  ref: "pdpContainer",
  class: "pdp-container ut-pdpContent"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_pdp_display = _resolveComponent("pdp-display");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('pdp.title')), 1), _createElementVNode("div", _hoisted_5, [_createVNode(_component_pdp_display)], 512)])])]);
}